// The Axios instance uses transformResponse:[] so response bodies are raw strings, and the generated
// client throws ApiException("An unexpected server error occurred.") for any non-200 status, keeping
// the server's own body in error.response. This pulls the server's message back out of it.
export const getApiErrorMessage = (error: any, fallback: string): string => {
  let parsed: any = null;
  try {
    parsed = typeof error?.response === 'string' ? JSON.parse(error.response) : error?.response;
  } catch {
    /* body wasn't JSON */
  }

  const message = parsed?.message || parsed?.data?.message;
  if (typeof message === 'string' && message.trim()) return message;

  // A generated-client ApiException's own message is the generic one, which is no help to the user
  const own = error?.message;
  if (typeof own === 'string' && own.trim() && !own.startsWith('An unexpected server error occurred')) return own;

  return fallback;
};

// 400 means the server understood the request and refused it for a reason the user can act on
export const isClientError = (error: any): boolean => error?.status === 400;
